import axios from "axios";

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

const getCovidHistoryLatest = async (providerId) => {
  return (await axios.get(`${API_URL}/api/1/medical/covid/${providerId}`))?.data?.list?.[0];
};


export { getCovidHistoryLatest };
